export default __webpack_public_path__ + "static/media/line-arrow.a473cfda.svg";